var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":true,"variant":"danger"}},[_c('div',{staticClass:"iq-alert-icon"},[_c('i',{staticClass:"ri-information-line"})]),_c('div',{staticClass:"iq-alert-text"},[_vm._v("Access denied.")])])}
var staticRenderFns = []

export { render, staticRenderFns }